import axios from "axios";

const baseBackendURL =
  import.meta.env.MODE === "development"
    ? import.meta.env.VITE_BACKEND_URL
    : import.meta.env.VITE_BACKEND_URL_PROD;

export const baseURL = `${baseBackendURL}/api`;
export const baseURLAssets = `${baseBackendURL}`;
console.log("Base URL:", baseURL); // Add this line for debugging
const instance = axios.create({
  baseURL,
});
export default instance;
